import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { Button } from '../../../components/Button/Button';
import { Layout } from '../../../components/Layout/Layout';
import { Text } from '../../../components/Text/Text';

function SelectedSummary({
  isAllRowsSelected,
  selectedCount,
  totalCount,
  onToggleSelectAllRows,
}) {
  const intl = useIntl();
  const formatNumber = useFormatNumber();

  return (
    <Layout align="center" flex="none">
      <Text>
        <FormattedMessage
          id="Table.selectedSummary.selectedCount"
          defaultMessage={`{selectedCountLabel} {selectedCount, plural, =0 {items selected} one {item selected} other {items selected}}`}
          description="Text showing the number of selected items in a table. Example: # item selected = 'example', '# items selected' = 'example'"
          values={{
            selectedCount,
            selectedCountLabel: formatNumber(selectedCount),
          }}
        />
      </Text>
      <Button
        text={
          isAllRowsSelected
            ? intl.formatMessage({
                id: 'Table.selectedSummary.clearSelectionButton',
                defaultMessage: 'Clear selection',
                description: 'Button text to clear all selected rows',
              })
            : intl.formatMessage(
                {
                  id: 'Table.selectedSummary.selectAllButton',
                  defaultMessage:
                    'Select all ({totalCountLabel}) {totalCount, plural, =0 {items} one {item} other {items}}',
                  description:
                    'Button text to select all rows in a table. Example: (#) item = "example", (#) items = "example"',
                },
                {
                  totalCount,
                  totalCountLabel: formatNumber(totalCount),
                },
              )
        }
        variant="action"
        onClick={() => onToggleSelectAllRows(!isAllRowsSelected)}
      />
    </Layout>
  );
}

export default SelectedSummary;
